import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: "#263238",
                secondary: "#002B36",
                accent: "#27DEBF",
                fondo: "#FBFBFB",
                verdeClaro:"#93EEDF",
                verdeOscuro:"#1FB198",
                grisClaro:"#707070",
                info:"#b8b8b8",
                azulFondo:"#EDF1F7",
                verdeFondo:"#EDF7F3",
                boton: "#2EA2F8"
            }
        }
    }
  });
